import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PersonSearchResultDto } from '../services/api.service';

@Component({
  selector: 'cert-voucher-person-bucket',
  standalone: false,
  templateUrl: './voucher-person-bucket.component.html',
})
export class VoucherPersonBucketComponent {
  @Input() persons: PersonSearchResultDto[] = [];
  @Output() remove = new EventEmitter<number>();
  @Output() removeAll = new EventEmitter<void>();
}
